import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';

import { AuthService } from '../../../services/auth.service';
import { MessageSeverity, AlertService } from '../../../services/alert.service';
import { ReportService } from '../../../services/report.service';
import { Utilities } from '../../../services/utilities';
import { MatButtonModule } from '@angular/material/button';
import { AccountService } from '../../../services/account.service';
import { ODPProjectWorkflowViewModel } from '../../../models/odpprojectworkflow/odpProjectWorkflow.model';


@Component({
  selector: 'app-report-abstract-summary',
  templateUrl: './report-abstract-summary.component.html',
  styleUrls: ['./report-abstract-summary.component.css'],
  imports: [
    MatButtonModule
  ]
})
export class ReportAbstractSummaryComponent implements OnInit {

  activeProject: ODPProjectWorkflowViewModel;
  activeProjectTitle: string;

  getFilename = () => `AbstractSummary (${this.activeProjectTitle}) ${this.reportService.FormattedDateNoSeconds}.xlsx`;

  constructor(
    private accountService: AccountService,
    private alertService: AlertService,
    private authService: AuthService,
    private reportService: ReportService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.authService.isSessionExpired) {
      return this.router.navigateByUrl('/account/login');
    }
    this.activeProject = this.accountService.GetActiveProject();
    this.activeProjectTitle = this.activeProject.projectTitle;
  }

  onSubmit() {
    this.alertService.startLoadingMessage();

    var odpProjectWorkflowId = this.activeProject.odpProjectWorkflowId;

    this.reportService.getAbstractSummaryReport(odpProjectWorkflowId).subscribe({
      next: (data: ArrayBuffer) => {
        this.alertService.stopLoadingMessage();

        if (data) {
          const blob = new Blob([data], {type: this.reportService.ReportContentType});
          saveAs(blob, this.getFilename());
        } else {
          this.alertService.showStickyMessage('Empty Result', 'Abstract summary report returned an empty result.', MessageSeverity.warn);
        }
      },
      error: (error) => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage(
          'Server error',
          `An error ocurred while building the abstract summary report.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
          MessageSeverity.error,
          error);
    }});
  }
}
